export default __webpack_public_path__ + "static/media/preview.5f173ffc.png";